import m_15_2285 from './KZ.М.15.2285.svg'
import t_15_0798 from './KZ.T.15.0798.svg'
import t_15_0798_b from './KZ.T.15.0798 black.svg'

export default [
  m_15_2285,
  t_15_0798,
  t_15_0798_b,
]
